import { render, staticRenderFns } from "./DetailedSlotVacation.vue?vue&type=template&id=806bac7c&"
import script from "./DetailedSlotVacation.vue?vue&type=script&lang=ts&"
export * from "./DetailedSlotVacation.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedSlotVacation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports